import { Flex } from 'antd';
import React from 'react';
import DriverDetails from './DriverDetails';
import VehicleDetails from './VehicleDetails';
import PropTypes from 'prop-types';

const VehicleInfo = ({ selectedTripDetails, vehicleDetails }) => {
  return (
    <Flex vertical gap={10} className="full-height">
      <DriverDetails selectedTripDetails={selectedTripDetails} />
      <VehicleDetails vehicleDetails={vehicleDetails} />
    </Flex>
  );
};

VehicleInfo.propTypes = {
  selectedTripDetails: PropTypes.object,
  vehicleDetails: PropTypes.object,
};

export default React.memo(VehicleInfo);
